var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-button",class:{ 'text-button--inline': _vm.inline },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$slots.default[0].text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }